import axios from "axios";
import appConfig from "../config/app.config";
import {
  getAFUserId,
  getUtmCampaign,
  getUtmMedium,
  getUtmSource,
} from "../libs/events";
import { getUser, getUserToken, setUser, setUserToken } from "../libs/user";
import { makeGetRequest, makePostRequest } from "./makeRequest";

const getChannelSafe = () => {
  try {
    const fromSession = window.sessionStorage.getItem("channel") || "";
    if (fromSession) return fromSession;
  } catch (e) {
    // ignore
  }
  try {
    const url = new URL(window.location.href);
    return url.searchParams.get("channel") || "";
  } catch (e) {
    return "";
  }
};

const shouldSendRecaptchaHeader = () => getChannelSafe() !== "TOI";

const userLogin = (email, password, reCaptcha, deviceId) => {
  return new Promise((resolve, reject) => {
    const data = JSON.stringify({
      email: email,
      password: password,
      af_user_id: getAFUserId(),
    });

    const config = {
      method: "post",
      url: appConfig.apiUrl.userLogin,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        "Access-Control-Allow-Headers": "Content-Type",
        action: "login",
        "Device-Id": deviceId,
        "channel": getChannelSafe(),
      },
      data: data,
    };
    if (shouldSendRecaptchaHeader() && reCaptcha) {
      config.headers.recaptcha = reCaptcha;
    }

    axios(config)
      .then((response) => {
        setUser(response.data)
          .then((data) => {
            resolve(data);
          })
          .catch((error) => {
            reject(error);
          });
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const mobileLoginService = (mobile_number, reCaptcha, deviceId) => {
  return new Promise((resolve, reject) => {
    const data = JSON.stringify({
      mobile_number: mobile_number,
      af_user_id: getAFUserId(),
    });

    const config = {
      method: "post",
      url: appConfig.apiUrl.mobileLogin,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        "Access-Control-Allow-Headers": "Content-Type",
        action: "login",
        "Device-Id": deviceId,
        "channel": getChannelSafe(),
      },
      data: data,
    };
    if (shouldSendRecaptchaHeader() && reCaptcha) {
      config.headers.recaptcha = reCaptcha;
    }

    axios(config)
      .then((response) => {
        setUser({ ...response.data, phone: mobile_number })
          .then((data) => {
            resolve(data);
          })
          .catch((error) => {
            reject(error);
          });
      })
      .catch((error) => {
        reject(error);
      });
  });
};
const userSignup = (userObj, reCaptcha, deviceId, isEmailSignup = false) => {
  return new Promise((resolve, reject) => {
    const everflowTxnId = userObj?.everflowTxnId || "";
    const signupSource = userObj?.signupSource || "";
    const body = userObj?.everflowTxnId
      ? {
          ...userObj,
          utm_source: "everflow",
          utm_content: everflowTxnId,
        }
      : {
          ...userObj,
          utm_source: signupSource || getUtmSource(),
          utm_medium: getUtmMedium(),
          utm_campaign: getUtmCampaign(),
        };
    const data = JSON.stringify(body);

    const config = {
      method: "post",
      url: isEmailSignup
        ? appConfig.apiUrl.userSignupWithEmail
        : appConfig.apiUrl.userSignupWithMobile,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        "Access-Control-Allow-Headers": "Content-Type",
        "Device-Id": deviceId,
        action: "signup",
        "channel": getChannelSafe(),
      },
      data: data,
    };
    if (shouldSendRecaptchaHeader() && reCaptcha) {
      config.headers.recaptcha = reCaptcha;
    }

    axios(config)
      .then((response) => {
        if (isEmailSignup) {
          console.log(response);
          setUserToken(response?.data?.token);
        }

        resolve(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const verifyOtpService = (
  mobile_number,
  otp,
  message_id,
  fingerprint,
  utm_source = "",
  updateUser = true
) => {
  return new Promise((resolve, reject) => {
    const data = JSON.stringify({
      mobile_number: mobile_number,
      otp: otp,
      message_id: message_id,
      utm_source,
    });

    const config = {
      method: "post",
      url: appConfig.apiUrl.verifyOtp,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        "Access-Control-Allow-Headers": "Content-Type",
        "Device-Id": fingerprint.data,
      },
      data: data,
    };

    axios(config)
      .then((response) => {
        if (updateUser) {
          setUser(response.data).then((data) => {
            resolve(data);
          });
        }
      })
      .catch((error) => {
        reject(error);
      });
  });
};
const getProfileService = (token) => {
  return new Promise((resolve, reject) => {
    var config = {
      method: "get",
      url: appConfig.apiUrl.updateProfile,
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    axios(config)
      .then(function (response) {
        const obj = Object.assign(response.data, { token: token });
        setUser(response.data);
        resolve(obj);
      })
      .catch(function (error) {
        reject(error);
      });
  });
};

const updateProfileService = (firstName, lastName, email, token) => {
  return new Promise((resolve, reject) => {
    const data = JSON.stringify({
      first_name: firstName,
      last_name: lastName,
      email: email,
    });

    const config = {
      method: "put",
      url: appConfig.apiUrl.updateProfile,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        "Access-Control-Allow-Headers": "Content-Type",
        Authorization: `Bearer ${token}`,
      },
      data: data,
    };
    axios(config)
      .then((response) => {
        // const {
        //   user: { customer_id, mobile_number, sign_up_source, email } = {},
        // } = response.data;

        // // Identify user with Segment
        // loginSegmentEvent(customer_id, {
        //   customer_id,
        //   email,
        //   mobile_number,
        //   signup_source: sign_up_source,
        //   first_name: firstName,
        //   last_name: lastName,
        // });
        setUser(response.data);
        resolve(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const loginVerifyOtpService = (mobile_number, otp, message_id) => {
  return new Promise((resolve, reject) => {
    const data = JSON.stringify({
      mobile_number: mobile_number,
      otp: otp,
      message_id: message_id,
    });

    const config = {
      method: "post",
      url: appConfig.apiUrl.loginVerifyOtp,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        "Access-Control-Allow-Headers": "Content-Type",
      },
      data: data,
    };

    axios(config)
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};
const resendOtpService = (mobile_number, message_id) => {
  return new Promise((resolve, reject) => {
    const data = JSON.stringify({
      mobile_number: mobile_number,
      message_id: message_id,
    });

    const config = {
      method: "post",
      url: appConfig.apiUrl.resendOtp,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        "Access-Control-Allow-Headers": "Content-Type",
      },
      data: data,
    };

    axios(config)
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};
const updateResendOtpService = (mobile_number, message_id, token) => {
  return new Promise((resolve, reject) => {
    const data = JSON.stringify({
      mobile_number: mobile_number,
      message_id: message_id,
    });

    const config = {
      method: "post",
      url: appConfig.apiUrl.updateResendOtp,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        "Access-Control-Allow-Headers": "Content-Type",
        Authorization: `Bearer ${token}`,
      },
      data: data,
    };

    axios(config)
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const updatePhoneService = (mobile_number, token) => {
  return new Promise((resolve, reject) => {
    const data = JSON.stringify({
      mobile_number,
    });
    const config = {
      method: "post",
      url: appConfig.apiUrl.updatePhone,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        "Access-Control-Allow-Headers": "Content-Type",
        Authorization: `Bearer ${token}`,
      },
      data: data,
    };
    axios(config)
      .then(async (response) => {
        const storedUserData = await getUser();
        setUser({
          ...storedUserData,
          ...response?.data,
          message_id: response.data?.message_id,
        });
        resolve(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};
const updatedVerifyOtp = (
  mobile_number,
  otp,
  message_id,
  verify_otp_type,
  token
) => {
  return new Promise((resolve, reject) => {
    const data = JSON.stringify({
      mobile_number,
      otp,
      message_id,
      verify_otp_type,
    });

    const config = {
      method: "post",
      url: appConfig.apiUrl.verifyUpdatedOtp,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        "Access-Control-Allow-Headers": "Content-Type",
        Authorization: `Bearer ${token}`,
      },
      data: data,
    };

    axios(config)
      .then((response) => {
        // setUser(response.data);

        resolve(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const reauthenticateService = (login_type, token, mobile_number) => {
  return new Promise((resolve, reject) => {
    const data = JSON.stringify({
      login_type,
      mobile_number,
    });

    const config = {
      method: "post",
      url: appConfig.apiUrl.reauthenticate,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        "Access-Control-Allow-Headers": "Content-Type",
        Authorization: `Bearer ${token}`,
      },
      data: data,
    };

    axios(config)
      .then((response) => {
        setUser(response.data);
        resolve(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};
const validateEmail = (email) => {
  return new Promise((resolve, reject) => {
    const data = JSON.stringify({
      email: email,
    });

    const config = {
      method: "post",
      url: appConfig.apiUrl.validEmail,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    axios(config)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const forgotPassword = (email) => {
  return new Promise((resolve, reject) => {
    const data = JSON.stringify({
      email: email,
    });

    const config = {
      method: "post",
      url: appConfig.apiUrl.forgotPassword,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        "Access-Control-Allow-Headers": "Content-Type",
      },
      data: data,
    };

    axios(config)
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const validateOTP = (email, otp) => {
  return new Promise((resolve, reject) => {
    const data = JSON.stringify({
      email: email,
      otp: otp,
    });

    const config = {
      method: "put",
      url: appConfig.apiUrl.validateOTP,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    axios(config)
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const resetPassword = (email, otp, password, confirmPassword) => {
  return new Promise((resolve, reject) => {
    const data = JSON.stringify({
      email: email,
      otp: otp,
      password: password,
      confirm_password: confirmPassword,
    });

    const config = {
      method: "post",
      url: appConfig.apiUrl.resetPassword,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    axios(config)
      .then(function (response) {
        resolve(response.data);
      })
      .catch(function (error) {
        reject(error);
      });
  });
};

const userLogout = (token) => {
  return new Promise((resolve, reject) => {
    const config = {
      method: "delete",
      url: appConfig.apiUrl.userLogout,
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    axios(config)
      .then(function (response) {
        resolve(response.data);
      })
      .catch(function (error) {
        reject(error);
      });
  });
};

const getUserProfile = (token) => {
  return new Promise((resolve, reject) => {
    var config = {
      method: "get",
      url: appConfig.apiUrl.getUserProfile,
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    axios(config)
      .then(function (response) {
        const obj = Object.assign(response.data, { token: token });
        resolve(obj);
      })
      .catch(function (error) {
        reject(error);
      });
  });
};

const verifyPasswordReset = (obj) => {
  return new Promise((resolve, reject) => {
    var data = JSON.stringify(obj);

    var config = {
      method: "post",
      url: appConfig.apiUrl.verifyPasswordReset,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    axios(config)
      .then(function (response) {
        resolve(response.data);
      })
      .catch(function (error) {
        reject(error);
      });
  });
};
const passwordReset = (obj) => {
  return new Promise((resolve, reject) => {
    var data = JSON.stringify(obj);

    var config = {
      method: "post",
      url: appConfig.apiUrl.passwordReset,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    axios(config)
      .then(function (response) {
        resolve(response.data);
      })
      .catch(function (error) {
        reject(error);
      });
  });
};

const sendMeLink = (obj) => {
  return new Promise((resolve, reject) => {
    var data = JSON.stringify(obj);

    var config = {
      method: "post",
      url: appConfig.apiUrl.sendMeLink,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    axios(config)
      .then(function (response) {
        resolve(response.data);
      })
      .catch(function (error) {
        reject(error);
      });
  });
};

const getLinkToken = (token, fingerprint) => {
  return new Promise((resolve, reject) => {
    var config = {
      method: "get",
      url: `${appConfig.apiUrl.linkToken}?request_type=GET_USER&source=REMITTANCE`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Device-Id": fingerprint,
        "nb-sso-enabled": true,
      },
    };

    axios(config)
      .then(function (response) {
        resolve(response.data);
      })
      .catch(function (error) {
        reject(error);
      });
  });
};

const resgisterPassKeyService = async () => {
  const token = getUserToken();
  const registerPassKeyRes = await makeGetRequest(
    appConfig.apiUrl.initiateRegisterPasskey,
    {
      Authorization: `Bearer ${token}`,
    }
  );
  console.log("reshiterPassKeyData", registerPassKeyRes.data);
  return registerPassKeyRes.data;
};

const completeResgisterPassKeyService = async (data) => {
  const token = getUserToken();
  const completeResgisterPassKeyRes = await makePostRequest(
    appConfig.apiUrl.completeRegisterPasskey,
    data,
    {
      Authorization: `Bearer ${token}`,
    }
  );
  console.log(
    "completeResgisterPassKeyService",
    completeResgisterPassKeyRes.data
  );
  return completeResgisterPassKeyRes.data;
};

const initiatePassKeyloginService = async () => {
  const initiatePassKeyloginRes = await makeGetRequest(
    appConfig.apiUrl.initiatePasskeyLogin
  );
  console.log("initiatePassKeyloginRes", initiatePassKeyloginRes.data);
  return initiatePassKeyloginRes.data;
};

const completeloginWithPassKeyService = async (data, deviceId) => {
  const completeResgisterPassKeyRes = await makePostRequest(
    appConfig.apiUrl.completePasskeyLogin,
    data,
    {
      "Device-Id": deviceId,
    }
  );
  console.log(
    "completeResgisterPassKeyService",
    completeResgisterPassKeyRes.data
  );
  return completeResgisterPassKeyRes.data;
};

const getRegistedredPassKeyService = async () => {
  const token = getUserToken();
  const registeredPassKeysRes = await makeGetRequest(
    appConfig.apiUrl.registeredPassKeys,
    {
      Authorization: `Bearer ${token}`,
    }
  );
  console.log("registeredPassKeysRes", registeredPassKeysRes.data);
  return registeredPassKeysRes.data;
};

export {
  validateEmail,
  userSignup,
  verifyOtpService,
  loginVerifyOtpService,
  userLogin,
  mobileLoginService,
  forgotPassword,
  validateOTP,
  resetPassword,
  userLogout,
  resendOtpService,
  getUserProfile,
  verifyPasswordReset,
  updateProfileService,
  passwordReset,
  sendMeLink,
  updatePhoneService,
  updatedVerifyOtp,
  updateResendOtpService,
  getProfileService,
  getLinkToken,
  reauthenticateService,
  resgisterPassKeyService,
  completeResgisterPassKeyService,
  initiatePassKeyloginService,
  completeloginWithPassKeyService,
  getRegistedredPassKeyService,
};
